import { compose } from 'recompose';
import { withNamespaces } from 'react-i18next';

import { connect } from 'react-redux';
import CustomersList from './customersList';
import preloaderWhileLoading from '../../../../utils/enchancers/preloaderWhileLoading';
import { PRELOADER_DIMENSION } from '../../../../constants/ui';
import { customersSelectors } from '../../../../state/customers';

const mapStateToProps = state => ({
  isPending: customersSelectors.getPendingGetCustomers(state),
});

const enhance = compose(
  connect(mapStateToProps),
  withNamespaces(['common', 'chat']),
  preloaderWhileLoading({
    dimension: PRELOADER_DIMENSION.EXTRA_SMALL,
    alignContainerCenter: true,
    delay: 600,
    isLoading: () => false,
    onAction: ({ isPending }) => isPending,
  }),
);

export default enhance(CustomersList);
